export enum Breakpoints {
  xs = 'Xs',
  sm = 'Sm',
  md = 'Md',
  lg = 'Lg',
  xl = 'Xl',
  xxl = 'XXl'
}
